import React from 'react';
import { useNavigate, useParams } from 'react-router-dom'
const CardComponent = ({ cardData }) => {
  const navigate = useNavigate();
  const params = useParams()
  const colors = {
    "pending": "bg-light-badgeApinprogress !text-[#000]",
    "freeze pending": "bg-light-badgeApinprogress",
    "unfreeze pending": "bg-light-badgeApinprogress",
    "rejected": "bg-light-badgeRed",
    "failed": "bg-light-badgeRed",
    "suspended": "bg-light-badgeRed",
    "cancelled": "bg-light-badgeRed",
    "under maintenance": "bg-light-badgeApinprogress",
    "submitted": "bg-light-textBlue",
    "unfreeze": "bg-light-graystatus",
    "unfreezed": "bg-light-graystatus",
    "freeze": "bg-light-graystatus",
    "freezed": "bg-light-graystatus",
    "active": "bg-light-badgeGreen",
    "inactive": "bg-light-badgeRed",
    "approved": "bg-light-badgeGreen",
    "freeze failed": "bg-light-badgeRed",
    "unfreeze failed": "bg-light-badgeRed","reviewing":"bg-light-textBlue"
  }
  return (
    <div
      className='relative'
      onClick={() => {
        navigate(`/customer/${params?.custId}/Cards/cardDetails/${cardData?.id}`);
      }}
    >
      {cardData?.logo && <img src={cardData?.logo} alt="Card Logo" className='md:w-[380px] h-[200px] rounded-lg border-light-secondaryColor border cursor-pointer object-cover' height='100%' />}
      <div className='absolute top-3 left-3 right-3'>
        <div className=' gap-3 mb-0'>
          <p className='text-light-bgWhite text-sm mb-0.5' >{cardData?.cardName}</p>
          <span className={`px-2 py-[2px] block rounded-full text-[12px] text-light-bgWhite w-fit ${colors[cardData?.state?.toLowerCase()] || "green-bg"}`}>
            {cardData?.state?.toLowerCase() == "approved" ? "Active" : cardData?.state}
          </span>
        </div>
      </div>
      <div className='absolute bottom-3 left-3'>
        <div className='flex-1 mt-auto'>
          <p className='text-light-bgWhite' >Card Owner</p>
          <div className=''>
            <p className='text-light-bgWhite'>{cardData?.userName}</p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CardComponent;
